import * as  React from 'react'
import { SystemLink } from '../tools/SystemLink'
import { ISystemSideBarItem } from './ISystemSideBarItem'

//const scrollDivStyle: React.CSSProperties = {
//    position: "relative",
//    overflow: "hidden",
//    width: "auto",
//    height: "939px"
//}

//const sideBarStyle: React.CSSProperties = {
//    height: "939px",
//    overflow: "hidden",
//    width: "auto"
//}

//const scrollBarStyle: React.CSSProperties = {
//    background: "rgba(0, 0, 0, 0.3)",
//    width: "5px",
//    position: "absolute",
//    top: "0px",
//    opacity: "0.4",
//    display: "none",
//    borderRadius: "7px",
//    zIndex: 99,
//    right: "1px",
//    height: "939px"
//}

const miniScrollBarStyle: React.CSSProperties = {
    width: "5px",
    height: "100%",
    position: "absolute",
    top: "0px",
    display: "none",
    borderRadius: "7px",
    background: "rgb(51, 51, 51)",
    opacity: "0.2",
    zIndex: 90,
    right: "1px"
}
export interface ISystemSideBar {
    items?: ISystemSideBarItem[]
}

export const SystemSideBar = (props: ISystemSideBar) =>
    <aside className="main-sidebar fixed offcanvas b-r" data-toggle="offcanvas">
        <div className="slimScrollDiv" >
            <section className="sidebar">
                <ul className="sidebar-menu">
                    {props.items ? props.items.map((item, index) => {
                        return <li key={index}>
                            <SystemLink to={`${item.link}`}>
                                <i className={"icon " + item.iconClassName + " s-18"}></i> <span>{item.label}</span>
                            </SystemLink>
                        
                        </li>
                    }): null }
                </ul>
            </section>
            <div className="slimScrollBar"> </div>
            <div className="slimScrollRail" style={miniScrollBarStyle }></div></div>
    </aside>